import React, { Component } from 'react';
import { Icon } from 'antd';
import SearchRetrieve from './SearchRetrieve.new.js';

const DefaultBtn = function(props) {
    return (
        <Icon
            type="plus-circle-o"
            style={{ position: 'relative', top: 2, marginLeft: 10, fontSize: '18px', color: '#108ee9', cursor: 'pointer' }}
            {...props}
        />
    );
}

class SearchRetrieveBtn extends Component {
    state = {
        value: {},
    }

    handleChange = (value) => {
        this.setState({ value });
    }

    handleClick = () => {
        const { value } = this.state;
        this.props.onChange(value);
        this.setState({ value: {} });
    }

    render() {
        const { btn, ...rest } = this.props;
        const { value } = this.state;
        const Btn = btn || DefaultBtn;
        return (
            <div>
                <SearchRetrieve
                    {...rest}
                    value={value ? value.text : ''}
                    onChange={this.handleChange}
                />
                {
                    value.text ?
                        <Btn onClick={this.handleClick} />
                    :
                        <Btn disabled={true} />
                }
            </div>
        );
    }
}

export default SearchRetrieveBtn;


// WEBPACK FOOTER //
// ./src/components/common/SearchRetrieveBtn.js